import { getToken } from "@/utils/auth";
import request from "@/utils/request";

// 获取验证码
export function login(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/index.php?app=login&mod=index",
      method: "post",
      data
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}
// 拿号码
export function getMemberPhone() {
  return request({
    url: "/index.php?app=usercenter&mod=memberInfo&key=" + getToken(),
    method: "get"
  });
}
// 登录
// export function login(data) {
//   return request({
//     url: "/Account/quickLogin",
//     method: "post",
//     data
//   });
// }

export function getInfo(token) {
  return request({
    url: "/vue-admin-template/user/info",
    method: "get",
    params: { token }
  });
}

export function logout() {
  return request({
    url: "/admin/login/loginOut",
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js